// extracted by mini-css-extract-plugin
export default {"amazonPayModeSection":"a9-z"};